import { BoxWrapper } from "../../DropdownMenu.tsx/Styled";
import { color } from "../../../styles";
import styled from "styled-components";
import Menu from "@mui/material/Menu";

export const StyledButton = styled(BoxWrapper)`
  && {
    width: auto;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    border: 1px solid ${color.secondary.BORDER};
    border-radius: 8px;
    background-color: white;
    cursor: pointer;
    color: ${color.secondary.DARK_GREY};
  }
`;

export const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    width: 100%;
    padding: 8px 8px 10px 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    box-sizing: border-box;
    justify-content: flex-start;
  }
`;